import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  agreement: false,
  canFileSend: true,
};

// Slice
const fileUploadSlice = createSlice({
  name: "fileUpload",
  initialState,
  reducers: {
    initFileUpload(state) {
      return { ...state, agreement: false, canFileSend: true };
    },
    fileUploadAgree(state, action) {
      const { agreement } = action.payload;
      return { ...state, agreement };
    },
    fileUploadSet(state, action) {
      const { canFileSend } = action.payload;
      return { ...state, canFileSend };
    },
  },
});

export const { initFileUpload, fileUploadAgree, fileUploadSet } =
  fileUploadSlice.actions;

export default fileUploadSlice.reducer;
